import ChurnedOrPreviewProfilePage from './ChurnedOrPreviewProfilePage';
import { BasePaths, pageName } from '../ActiveProfile/constants';
import reducers from '../ActiveProfile/reducers';
import renderPage from '../../config/renderPage';
import { gaPageViewMiddleware, dataLakeMiddleware } from '../../middleware/pageView';
import analytics from '../ActiveProfile/analytics';

const el = document.getElementById('main');

renderPage({
    el,
    reducers,
    initialState: window.__REDUX_STATE__,
    routes: BasePaths.map(path => ({
        path,
        component: ChurnedOrPreviewProfilePage,
    })),
    pageName,
    preGaCustomMiddleware: [
        gaPageViewMiddleware(analytics, window.location),
        dataLakeMiddleware(window.location, window.document, analytics),
    ],
});
